module.exports = __webpack_public_path__ + "img/logo.edbcca0f.svg";